import { render, staticRenderFns } from "./ToastificationContentTicket.vue?vue&type=template&id=a5f246a0&scoped=true&"
import script from "./ToastificationContentTicket.vue?vue&type=script&lang=js&"
export * from "./ToastificationContentTicket.vue?vue&type=script&lang=js&"
import style0 from "./ToastificationContentTicket.vue?vue&type=style&index=0&id=a5f246a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f246a0",
  null
  
)

export default component.exports